'use client';
import { useMutation } from '@tanstack/react-query';
import Axios from '@/lib/axiosConfig';
import { useAuth } from '@/context/Auth';
import { ShareEntityType } from './types/shareEntityType'

export interface ShareRequestBody {
  shareEntityType: ShareEntityType;
  recipientUserIDs?: string[];
  shareEntityID: string;
  recipientEmails?: string[];
  personalNote:string;
  isInvite: boolean;
  shareEntityTitle?:string;
}

export const useShareContent = () => {
  const { getAPIRequestTokenHeaders } = useAuth();
  return useMutation({
    mutationFn: async (payload: ShareRequestBody) =>
      Axios.post(
        '/share',
        payload,
        { headers: getAPIRequestTokenHeaders() }
      ),
  });
};
